@if (!consent.hasDecision()) {
  <div class="cookie-consent" role="dialog" aria-live="polite"
       [attr.aria-label]="'consent.accept' | translate">
    <p class="cookie-consent__text">
      {{ 'consent.message' | translate }}
      <a routerLink="/datenschutz">{{ 'consent.more' | translate }}</a>
    </p>
    <div class="cookie-consent__actions">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="consent.reject()">
        {{ 'consent.reject' | translate }}
      </button>
      <button type="button" class="btn btn-primary btn-sm" (click)="consent.accept()">
        {{ 'consent.accept' | translate }}
      </button>
    </div>
  </div>
}
